/** Produktions-Default, falls keine Env gesetzt ist (verhindert kaputte /login-Links). */
export const DEFAULT_PORTAL_ORIGIN = "https://portal.fl-care.com";

/**
 * Basis-URL der Portal-App (ohne trailing slash).
 * Reihenfolge: `PORTAL_PUBLIC_URL` (Server/Proxy), dann `NEXT_PUBLIC_PORTAL_URL` (Client+Build), sonst Default.
 */
export function resolvePortalOrigin(): string {
  const fromServer = (process.env.PORTAL_PUBLIC_URL ?? "").trim().replace(/\/$/, "");
  const fromPublic = (process.env.NEXT_PUBLIC_PORTAL_URL ?? "").trim().replace(/\/$/, "");
  return fromServer || fromPublic || DEFAULT_PORTAL_ORIGIN;
}

export function portalAppOrigin(): string {
  return resolvePortalOrigin();
}

export function portalLoginHref(lang: "de" | "en"): string {
  return `${resolvePortalOrigin()}/login?lang=${lang}`;
}
